import { ThematicDto } from "./thematicDto";
import { ExpositionImageDto } from "./expositionImageDto";
import { CountryDto } from "./countryDto";

export class ExpositionDto {
  expositionESId: string;
  expositionId: number;
  categoryId: number;
  titleFr: string;
  titleEn: string;
  dateExposition: string;
  descriptionFr: string;
  descriptionEn: number;
  countryId: number;
  listThematic: ThematicDto[];
  listExpositionImage: ExpositionImageDto[];
  listCountry: CountryDto[];
  numberDownload: number;
  numberView: number;
}
